import React, { useMemo } from "react";
import { CopyDetailProps } from "../../../../../../../service/homework";
import QuestDanxuan from "../../../../../component/Rows/components/QuestDanxuan";
import { QuestionType } from "../../../../../../../service/service";
import QuestDuoxuan from "../../../../../component/Rows/components/QuestDuoxuan";
import QuestZhuguan from "../../../../../component/Rows/components/QuestZhuguan";
import QuestTianKong from "../../../../../component/Rows/components/QuestTianKong";
import QuestCompound from "../../../../../component/Rows/components/QuestCompound";

interface Props {
    item: CopyDetailProps;
    index: number;
}
const Index = ({ item, index }: Props) => {
    const defaultProps = useMemo(() => {
        const { topicId, trunk, answers } = item;
        return {
            key: topicId,
            index,
            trunk,
            answers,
            correct: true,
            contentText: item.contentText,
            isHomework: true,
            topicId: item.topicId,
            onChange: () => {},
            score: item.score,
            comment: item.comment,
            markScore: item.markScore,
            topics: item.topics
        };
    }, [item, index]);

    return useMemo(() => {
        switch (item.type) {
            case QuestionType.DanXuan:
                return <QuestDanxuan {...defaultProps} />;
            case QuestionType.DuoXuan:
                return <QuestDuoxuan {...defaultProps} />;
            case QuestionType.PanDuan:
                return <QuestDanxuan {...defaultProps} />;
            case QuestionType.ZhuGuan:
                return <QuestZhuguan {...defaultProps} />;
            case QuestionType.TianKong:
                return <QuestTianKong {...defaultProps} />;
            case QuestionType.TingLi:
                return <QuestCompound {...defaultProps} />;
            case QuestionType.WanXingTianKong:
                return <QuestCompound {...defaultProps} />;
            case QuestionType.YueDuLiJie:
                return <QuestCompound {...defaultProps} />;
            default:
                return <p>null</p>;
        }
    }, [item]);
};

export default Index;
